import React from "react";
import styles from "./styles";
// MATERIAL UI
import { withStyles } from "@mui/styles";
import { Typography, Grid } from "@mui/material/";

class Timer extends React.Component {
  render() {
    const { classes, timer } = this.props;
    let minutes = Math.floor(timer / 60);
    let seconds = timer % 60;
    //Anteponiendo un 0 a los minutos si son menos de 10
    minutes = minutes < 10 ? "0" + minutes : minutes;
    //Anteponiendo un 0 a los segundos si son menos de 10
    seconds = seconds < 10 ? "0" + seconds : seconds;
    let result = minutes + ":" + seconds; // 161:3
    return (
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{
          borderRadius: "10px",
          padding: "10px 20px",
          backgroundColor: "#fff"
        }}
      >
        <Grid item xs={12} md={12}>
          <Typography
            variant="subtitle1"
            color="textSecondary"
            align="center"
            className={classes.textTime}
          >
            Tiempo restante
          </Typography>
          <Typography
            variant="h5"
            color="textSecondary"
            align="center"
            className={classes.textTimer}
          >
            {result}
          </Typography>
        </Grid>
      </Grid>
    );
  }

  componentDidMount() {
    this.doIntervalChange();
  }

  doIntervalChange = () => {
    this.myInterval = setInterval(() => {
      if (this.props.timer <= 0) {
        clearInterval(this.myInterval);
        this.props.updateFinished(
          "Acabas de superar el primer nivel de este Electri-Grama. Continua ganando para llegar al los Top 100"
        );
      } else {
        this.props.updateTimer();
      }
    }, 1000);
  };

  componentWillUnmount() {
    clearInterval(this.myInterval);
  }
}

export default withStyles(styles)(Timer);
